import axios from "axios";
import NoteRequestModel from "@/features/Notes/RequestModels/NoteRequestModel";

export class NoteService {
    private noteURL = "/api/v1/notes";

    async createNote(note: NoteRequestModel): Promise<string> {
        const response = await axios.post(this.noteURL, note);
        return response.data;
    }

    async getDocumentByArchiveID(id: string, docArchiveID: string, filename: string): Promise<void> {
        try {
            // Add an HTML anchor element to the page linking to the document to download
            const anchor = document.createElement("a");
            document.body.appendChild(anchor);
            const requestPath = this.noteURL + "/" + id + "/document/" + docArchiveID;

            // Get document from server and prepare to download it to browser
            const blob = (await axios.get(requestPath, { responseType: "blob" })).data as Blob;
            const objectUrl = window.URL.createObjectURL(blob);

            anchor.href = objectUrl;
            anchor.download = filename;

            // Click the link to download the document
            anchor.click();

            // Clean up the link
            window.URL.revokeObjectURL(objectUrl);
            document.body.removeChild(anchor);
        } catch (err) {
            console.log(err);
            alert(`Error downloading ${filename}`);
        }
    }
}
